import DisableSupportMessagesForm from './DisableSupportMessagesForm';

export default DisableSupportMessagesForm;
